import React from "react";

const SIZE = 512;
const CX = 256;
const CY = 256;
const ARM = 112;
const NODE_R = 58;
const LINK_W = 32;

const NODES = [
    { letter: "W", x: CX, y: CY - ARM },
    { letter: "O", x: CX - ARM, y: CY },
    { letter: "R", x: CX + ARM, y: CY },
    { letter: "D", x: CX, y: CY + ARM },
];

/** Diamond W–O–R–D plus the horizontal O–R bar from the current store icon. */
const LINKS = [
    [NODES[1], NODES[0]],
    [NODES[0], NODES[2]],
    [NODES[1], NODES[3]],
    [NODES[2], NODES[3]],
    [NODES[1], NODES[2]],
];

/**
 * Linked W-O-R-D mark from the Word Wheel Quest store icon.
 */
export default function WordWheelWordLinkMark({ idPrefix = "wwWordLink" }) {
    const id = (name) => `${idPrefix}-${name}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={SIZE}
            height={SIZE}
            viewBox={`0 0 ${SIZE} ${SIZE}`}
            role="img"
            aria-label="Linked W O R D"
        >
            <defs>
                <radialGradient id={id("glass")} cx="38%" cy="32%" r="72%">
                    <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.42" />
                    <stop offset="55%" stopColor="#FFFFFF" stopOpacity="0.18" />
                    <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.08" />
                </radialGradient>
                <radialGradient id={id("node")} cx="32%" cy="28%" r="78%">
                    <stop offset="0%" stopColor="#99F6E4" />
                    <stop offset="42%" stopColor="#2DD4BF" />
                    <stop offset="100%" stopColor="#0F766E" />
                </radialGradient>
                <linearGradient id={id("link")} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#5EEAD4" />
                    <stop offset="45%" stopColor="#14B8A6" />
                    <stop offset="100%" stopColor="#0F766E" />
                </linearGradient>
            </defs>

            <circle
                cx={CX}
                cy={CY}
                r="228"
                fill={`url(#${id("glass")})`}
                stroke="#FFFFFF"
                strokeOpacity="0.55"
                strokeWidth="10"
            />

            {LINKS.map(([a, b], index) => (
                <line
                    key={`shadow-${index}`}
                    x1={a.x}
                    y1={a.y + 4}
                    x2={b.x}
                    y2={b.y + 4}
                    stroke="#115E59"
                    strokeOpacity="0.35"
                    strokeWidth={LINK_W}
                    strokeLinecap="round"
                />
            ))}
            {LINKS.map(([a, b], index) => (
                <line
                    key={`link-${index}`}
                    x1={a.x}
                    y1={a.y}
                    x2={b.x}
                    y2={b.y}
                    stroke={`url(#${id("link")})`}
                    strokeWidth={LINK_W}
                    strokeLinecap="round"
                />
            ))}

            {NODES.map((node) => (
                <g key={node.letter}>
                    <circle cx={node.x} cy={node.y + 5} r={NODE_R} fill="#115E59" fillOpacity="0.28" />
                    <circle
                        cx={node.x}
                        cy={node.y}
                        r={NODE_R}
                        fill={`url(#${id("node")})`}
                        stroke="#CCFBF1"
                        strokeOpacity="0.55"
                        strokeWidth="3"
                    />
                    <ellipse
                        cx={node.x - 14}
                        cy={node.y - 16}
                        rx={NODE_R * 0.42}
                        ry={NODE_R * 0.28}
                        fill="#FFFFFF"
                        fillOpacity="0.28"
                    />
                    <text
                        x={node.x}
                        y={node.y + 2}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontFamily='Arial, "Helvetica Neue", sans-serif'
                        fontSize={node.letter === "W" ? 46 : 50}
                        fontWeight="800"
                        fill="#FFFFFF"
                        stroke="#134E4A"
                        strokeWidth="3.5"
                        paintOrder="stroke fill"
                    >
                        {node.letter}
                    </text>
                </g>
            ))}
        </svg>
    );
}
